export default __webpack_public_path__ + "b33fca40beb62979ce9377ba41bce1c1.png";